import { gql } from '@apollo/client';

/**
 * Provisions the selected signed PandaDoc documents into a group: for each
 * document the backend creates a user (if missing), a student, an agreement
 * and a single contribution. Documents are processed independently — an error
 * on one does not cancel the rest.
 */
export const ProvisionStudents = gql`
  mutation ProvisionPandaDocStudents(
    $groupId: ID!
    $contributionAmount: Float!
    $currency: String!
    $documents: [ProvisionDocOverrideInput!]!
  ) {
    provisionStudents(
      groupId: $groupId
      contributionAmount: $contributionAmount
      currency: $currency
      documents: $documents
    ) {
      results {
        pandadocId
        success
        skipped
        agreementId
        error
      }
      errors
    }
  }
`;

/**
 * Queues a full PandaDoc re-sync: the backend re-pulls the document list,
 * marks student documents missing a folder for a details backfill and drains
 * the whole backlog itself over several passes. No arguments — the frontend
 * just triggers it and polls `pandadocSyncStatus` for progress.
 */
export const TriggerPandadocSync = gql`
  mutation RunPandaDocSync {
    triggerPandadocSync {
      enqueued
      message
      syncStatus {
        documentsCount
        detailsPending
        lastListSyncAt
        lastDetailsSyncAt
        lastError
      }
    }
  }
`;
